import React from 'react';
import PageLayout from '../../ui/PageLayout';
import PageHeader from '../../ui/PageHeader';

export default function ArchitectureWorldLayout({ children }) {
  return (
    <PageLayout
      header={<PageHeader title="Mudo Architecture" />}
    >
      {children}
    </PageLayout>
  );
}